const UAParser = require('ua-parser-js');
const _ = require('./i18n');

function appendCopyright() {
  // if old browser return
  if (!window.getSelection) return;

  const selection = window.getSelection();
  const selectedText = selection.toString();

  // do not add link if selected text<100
  if ((selectedText).length < 100) return;

  const url = document.location.href;
  const pagelink = _.interpolate(_('Source: %s'), [`<a href="${url}">${url}</a>`]);
  const simpleLink = `<br><br>${pagelink}`;
  const copiedText = `${selectedText}<br><br>${pagelink}`;

  // create element with desired copied text and sourse remark
  // insert it to document
  const selectionWrapper = document.createElement('div');
  selectionWrapper.style.position = 'absolute';
  selectionWrapper.style.left = '-99999px';
  document.body.appendChild(selectionWrapper);

  const range = document.createRange();
  const ua = UAParser();

  if (ua.browser.name === 'Firefox') {
    selectionWrapper.innerHTML = simpleLink;

    // make element with link a range object
    range.selectNode(selectionWrapper);
    selection.addRange(range);
  } else {
    selectionWrapper.innerHTML = copiedText;

    // make element with copied text a range object
    range.selectNode(selectionWrapper);

    // all browsers exept Firefox don't able to add extra Range to
    // the previous one
    selection.removeAllRanges();
    selection.addRange(range);
  }

  // clear document
  setImmediate(() => {
    document.body.removeChild(selectionWrapper);
  });
}

module.exports = appendCopyright;
